import { __assign, __rest } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import './styles/TextFieldWrapper.scss';
/**
 * Тут приходится присваивать функцию переменной, поскольку иначе стайлгайд почему-то начинает воспринимать её как компонент
 * @param controlId
 */
export var getAccessibilityAttributes = function getAccessibilityAttributes(controlId) {
    return {
        labelledBy: controlId + "_label",
        describedBy: controlId + "_error"
    };
};
/**
 * Хелпер разделяет свойства TextFieldWrapper (Кроме `className`) от остальных свойств.
 * `props.value`, и `props.disabled` остаются в обоих объектах.
 * @param props Свойства которые нужно поделить
 */
export var splitProps = function divideProps(props) {
    var className = props.className, error = props.error, label = props.label, suffix = props.suffix, variant = props.variant, errorVisible = props.errorVisible, otherProps = __rest(props, ["className", "error", "label", "suffix", "variant", "errorVisible"]);
    return {
        otherProps: otherProps,
        tfwProps: {
            className: className,
            error: error,
            label: label,
            suffix: suffix,
            variant: variant,
            errorVisible: errorVisible,
            value: otherProps.value,
            disabled: otherProps.disabled
        }
    };
};
export var VARIANT;
(function (VARIANT) {
    VARIANT["BIG"] = "big";
    VARIANT["STANDARD"] = "standard";
    VARIANT["SMALL"] = "small";
})(VARIANT || (VARIANT = {}));
export default function TextFieldWrapper(props) {
    var _a;
    var className = props.className, children = props.children, error = props.error, label = props.label, suffix = props.suffix, variant = props.variant, errorVisible = props.errorVisible, controlId = props.controlId, value = props.value, disabled = props.disabled, restProps = __rest(props, ["className", "children", "error", "label", "suffix", "variant", "errorVisible", "controlId", "value", "disabled"]);
    var classNames = cn((_a = {
            TextFieldWrapper: true
        },
        _a["TextFieldWrapper_size_" + variant] = true,
        _a.TextFieldWrapper_hasValue = !!value,
        _a.TextFieldWrapper_hasError = !!error,
        _a.TextFieldWrapper_disabled = disabled,
        _a), className);
    var a11yIds = getAccessibilityAttributes(controlId);
    var errorIsString = error && typeof error === 'string';
    return (React.createElement("label", __assign({}, restProps, { className: classNames }),
        React.createElement("div", { className: "TextFieldWrapper__main" },
            React.createElement("span", { id: a11yIds.labelledBy, className: cn({
                    TextFieldWrapper__placeholder: true,
                    TextFieldWrapper__placeholder_srOnly: errorIsString && errorVisible
                }) }, label),
            errorIsString && (React.createElement("span", { id: a11yIds.describedBy, "aria-live": "assertive", className: cn({
                    TextFieldWrapper__error: true,
                    TextFieldWrapper__error_srOnly: !errorVisible
                }) }, error)),
            children),
        React.createElement("div", { className: "TextFieldWrapper__suffix" }, suffix)));
}
TextFieldWrapper.defaultProps = {
    className: '',
    variant: VARIANT.STANDARD,
    error: null
};
TextFieldWrapper.divideProps = splitProps;
TextFieldWrapper.getAccessibilityAttributes = getAccessibilityAttributes;
TextFieldWrapper.VARIANT = VARIANT;
//# sourceMappingURL=TextFieldWrapper.js.map